import { z } from 'zod';

export const CreateAvonFollowUpNoteRequestSchema = z.object({
  memberId: z.string().uuid(),
  followUpDate: z.string().datetime(),
  // Time input should be in the format of HH:MM (e.g. 15:30)
  followUpTime: z
    .string()
    .regex(
      /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/,
      'Must be in the format of HH:MM (e.g. 15:30)'
    ),
  diagnosisIcdCodes: z.array(z.string().min(1)).optional(),
  diagnosisDescription: z.string().min(1),
  visitType: z.string().min(1),
  snomedCode: z.string().min(1),
  interactionId: z.number().int().positive(),
  shareWithPatient: z.boolean().optional().default(false),
});

export type CreateAvonFollowUpNoteRequestDto = z.infer<
  typeof CreateAvonFollowUpNoteRequestSchema
>;

export type AvonFollowUpNoteResponseDto = {
  avonNoteId: string;
};
